export enum Capability {
    ACCESS_RESOURCES = "accessResources",

    LIST_USERS = "listUsers",
    READ_USER = "readUser",
    UPDATE_USER = "updateUser",
    DELETE_USER = "deleteUser",
    INVITE_USER = "sendInvitation",
    DISABLE_USER = "disableUser",
    ENABLE_USER = "enableUser",
    ASSIGN_ROLE_ADMIN = "assignRoleAdmin",
    ASSIGN_ANY_CLUB = "assignAnyClub",
    MANAGE_ORGANIZATION = "manageOrganization",

    LIST_ORGANIZATIONS = "listOrganizations",
    CREATE_ORGANIZATION = "createOrganization",
    UPDATE_ORGANIZATION = "updateOrganization",
    DELETE_ORGANIZATION = "deleteOrganization",

    LIST_RESULTS = "listResults",
    CREATE_RESULT = "createResult",
    UPDATE_RESULT = "updateResult",
    DELETE_RESULT = "deleteResult",
}
